import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const DAVID_ROLES = [
  'sundial-role:DAVID_USER',
];

export const davidApplication = {
  name: ApplicationNames.DAVID,
  url: envConfig.apps.david,
  roles: DAVID_ROLES,
};
